<template>
    <div id="FormEmail">
        <div :class="`form-mail email-align-${localMailAlign}`">
            <input
                type="text"
                class="form-mail-input-label"
                v-model="localFieldEmail"
                @blur="updateField"
            />
            <div class="email-input-group">
                <input
                    type="email"
                    id="email"
                    class="form-mail-input"
                    v-model="localEmail"
                    @blur="updateField"
                />
                <label for="email" class="input-label">{{ altLabel }}</label>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "FormEmail",
    props: {
        fieldEmail: String,
        mailAlign: String,
        altLabel: String,
        isRequired: Boolean,
        item: Object,
    },
    data() {
        return {
            localFieldEmail: this.fieldEmail || "",
            localMailAlign: this.mailAlign || "",
            localEmail: "",
        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        updateField() {
            const updateFields = {
                label: this.localFieldEmail,
                email: {
                    fieldEmail: this.localFieldEmail,
                    mailAlign: this.localMailAlign,
                    email: this.localEmail,
                    isRequired: this.isRequired,
                },
            };
            this.updateFormField({
                siteId: this.item.siteId,
                formFieldId: this.item._id,
                updateFields: updateFields,
            });
            this.$emit("update-field", updateFields);
        },
    },
    watch: {
        fieldEmail(newVal) {
            this.localFieldEmail = newVal;
        },
        mailAlign(newVal) {
            this.localMailAlign = newVal;
        },
    },
};
</script>

<style lang="scss" scoped>
#FormEmail {
    font-family: Avenir, Helvetica, Arial, sans-serif;

    .email-align-right {
        display: flex;

        .form-mail-input-label {
            width: auto !important;
            text-align: right;
            margin-right: 30px;
            margin-bottom: 40px !important;
        }
    }

    .email-align-left {
        display: flex;

        .form-mail-input-label {
            width: auto !important;
            text-align: left;
            margin-right: 30px;
            margin-bottom: 40px !important;
        }
    }

    .form-mail {
        cursor: all-scroll;
        margin: 20px 0;

        .form-mail-input-label {
            display: block;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 8px;
            border: none;
            padding: 4px;
            width: 100%;
        }

        .email-input-group {
            display: flex;
            flex-direction: column;
            width: 100%;

            .form-mail-input {
                width: 100%;
                padding: 8px;
                border: 1px solid #ccc;
                border-radius: 4px;
                font-size: 14px;
            }

            .input-label {
                margin-top: 4px;
                font-size: 14px;
                color: #666;
                text-align: left;
            }
        }
    }
}
</style>
